module.exports = __webpack_public_path__ + "img/1490352736.12241279.jpg";